import { UsuarioRelatorioDTO, UsuariosRelatorioParmDTO } from "@/interfaces/users-report";
import { ENDPOINTS } from "@/settings/api-settings";
import { AxiosResponse } from "axios";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";


export function listUsersReportUserTypes(): Observable<Array<any>> {
    return from(
        apiClient.get(ENDPOINTS.USERS_REPORT_USER_TYPES),
    ).pipe(map((r: any) => r.data || {}));
}

export function listUsersReportProfiles(): Observable<Array<any>> {
    return from(
        apiClient.get(ENDPOINTS.USERS_REPORT_PROFILES),
    ).pipe(map((r: any) => r.data || {}));
}

export function listUsersReport(filters: UsuariosRelatorioParmDTO): Observable<Array<UsuarioRelatorioDTO>> {
    return from(
        apiClient.get(ENDPOINTS.USERS_REPORT, filters),
    ).pipe(map((r: any) => r.data || {}));
}

export function buildUsersXlsReport(filters: UsuariosRelatorioParmDTO): Observable<AxiosResponse> {
    return from(
        apiClient.download(ENDPOINTS.USERS_REPORT_XLS, filters),
    );
}

export function buildUsersPdfReport(filters: UsuariosRelatorioParmDTO): Observable<AxiosResponse> {
    return from(
        apiClient.download(ENDPOINTS.USERS_REPORT_PDF, filters),
    );
}